import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const Card = Styled.article`
display: inline-flex;
border-radius: 6px;
overflow: hidden;
background-color: ${color.white};
padding: 2rem 3rem;
max-width: 50rem;
display: grid;
grid-template-columns: 1fr 2fr;
place-items: center;
grid-gap: 1rem;
color:${color.primary};
@media only screen and (max-width: 700px){
grid-template-columns: 1fr;
grid-column-gap: 0;
max-width: 70%;
}
`;

const CardImage = Styled.figure`
background-color: ${color.primary};
margin-right: 2rem;
border-radius: 6px;
height: 100%;
width: 100%;
overflow: hidden;
img {
width: 100%;
height: 100%;
object-fit: cover;
};
@media only screen and (max-width: 700px){
  height: 10rem;
  width: 10rem;
  border-radius: 100rem;
}
`;

const Heading = Styled.h4`
color: var(--color-primary);
`;

const Paragraph = Styled.p`
max-width: 40ch;
font-size: 2rem;
margin: 1rem 0;
`;

const ReviewCard = ({ image, heading, paragraph }) => {
  return (
    <Card>
      <CardImage>
        <img src={image.img} alt={image.label} />
      </CardImage>
      <div>
        <Heading>{heading}</Heading>
        <Paragraph>“{paragraph}”</Paragraph>
      </div>
    </Card>
  );
};

export default ReviewCard;
